"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _FormLabel = _interopRequireWildcard(require("../FormLabel"));

var _FormMessage = _interopRequireDefault(require("../FormMessage"));

var _InputWidths = require("../InputWidths");

var _Translator = _interopRequireDefault(require("../../../util/i18n/Translator.js"));

var _underscore = _interopRequireDefault(require("underscore"));

var _Utils = _interopRequireDefault(require("../../../util/Utils.js"));

var _StateContainer = require("../../utils/StateContainer");

var _PropUtils = require("../../../util/PropUtils");

var _DeprecationUtils = require("../../../util/DeprecationUtils");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source))).call(_context6, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
/**
* @callback FormTextField~onChange
*
* @param {object} e
*     The ReactJS synthetic event object.
*

/**
* @callback FormTextField~onValueChange
*
* @param {string} value
*     The current text field value.
*/

/**
* @callback FormTextField~onBlur
*
* @param {object} e
*     The ReactJS synthetic event object.
*/

/**
* @callback FormTextField~onFocus
*
* @param {object} e
*     The ReactJS synthetic event object.
*/

/**
* @callback FormTextField~onKeyDown
*
* @param {object} e
*     The ReactJS synthetic event object.
*/

/**
* @callback FormTextField~onKeyPress
*
* @param {object} e
*     The ReactJS synthetic event object.
*/

/**
* @callback FormTextField~onMouseDown
*
* @param {object} e
*     The ReactJS synthetic event object.
*/

/**
* @callback FormTextField~onSave
*/

/**
* @callback FormTextField~onUndo
*/

/**
* @callback FormTextField~onToggleReveal
*/

/**
* @class FormTextField
* @desc A text field component.
*
* @param {string} [className]
*     CSS classes to set on the top-level HTML container.
* @param {node} [subText]
*     A node that will add text or a component below the textbox.
* @param {string} [data-id="form-text-field"]
*     To define the base "data-id" value for the top-level HTML container.
* @param {node} [description]
*     Description to display below the label.
* @param {node} [explanation]
*     Explanation text for the field appears below it.
* @param {string} [errorClassName]
*     CSS classes to set on the FormTextFieldError component.
* @param {node} [errorMessage]
*     The message to display if defined when external validation failed.
* @param {string} [helpClassName]
*     CSS classes to apply to the label help hint (bottom, left, etc)
* @param {string|element} [iconRight]
*     Icon to be rendered on the right side. If it is a string it will be passed to an Icon compononet
*     as the iconName. If the element is passed it will render the element.
* @param {string|element} [iconLeft]
*     Icon to be rendered on the left side. If it is a string it will be passed to an Icon compononet
*     as the iconName. If the element is passed it will render the element.
* @param {string} [inputClassName]
*     CSS classes to set on the input element.
* @param {boolean} [inline]
*     When true, text field is inline.
* @param {node} [labelHelpText]
*     A string or JSX object to display for the help tooltip.
* @param {string} [labelLockText]
*     The text to display for the lock help tooltip.
* @param {string} [labelText]
*     The text to show as the field's label.
* @param {string} [label]
*     Alias for labelText
* @param {number} [maxLength]
*     Maximum length supported by the text field.
* @param {string} [message]
*    The message text to display.
* @param {string} [messageType=error]
*    The type of message (error = red, info = blue, success = green, warning = yellow).
* @param {string} [name]
*     Name attribute on input
* @param {string} [placeholder]
*     Placeholder text for the input field.
* @param {number} [type]
*     An input type to be applied to the input. The input type often adds easily accessible and type-specific input
*     controls that often makes it easier to enter the field data.
* @param {string|number} [value=""]
*     Current text field value.
*     When not provided, the component will manage this value.
* @param {InputWidths} [width]
*    Specifies the width of the input.
*
* @param {boolean|string} [autoComplete="new-password"]
*     Whether or not the field will support autocomplete.
* @param {boolean} [autoFocus=false]
*     Whether or not to auto-focus the element.
* @param {boolean} [disabled=false]
*     If true, the text field will be disabled.
* @param {boolean} [flexWidth=false]
*     When true the width of the input will grow to fit the size of its content.
* @param {boolean} [maskValue=false]
*     If true, the value shown in the input field will be masked with '*****'. (i.e: passwords).
* @param {boolean} [noSpacing=false]
*     When true, the default margin is removed.
* @param {boolean} [readOnly=false]
*     Whether or not the input field is readonly.
* @param {boolean} [required=false]
*     If true, the user must select a value for this field.
* @param {boolean} [reveal=false]
*     If true, will remove value masking.
*     When not provided, the component will manage this value.
* @param {boolean} [showReveal=false]
*    Whether or not to display a reveal option to remove value masking.
* @param {boolean} [showSave=false]
*     Whether or not to display a save option.
* @param {boolean} [showUndo=false]
*     Whether or not to display an undo option.
* @param {boolean} [stateless]
*     WARNING. Default value for "stateless" will be set to true from next version.
*     To enable the component to be externally managed. True will relinquish control to the component's owner.
*     False or not specified will cause the component to manage state internally.
*
* @param {FormTextField~onChange} [onChange]
*     Callback to be triggered when the field value changes. It will receive the triggering event.
* @param {FormTextField~onValueChange} [onValueChange]
*     Callback to be triggered when the field value changes. It will receive the component's value.
* @param {FormTextField~onBlur} [onBlur]
*     Callback to be triggered when the field blurs (loses focus).
* @param {FormTextField~onFocus} [onFocus]
*     Callback to be triggered when the field gains focus.
* @param {FormTextField~onKeyDown} [onKeyDown]
*     Callback to be triggered when a key is pressed down in the field.
* @param {FormTextField~onKeyPress} [onKeyPress]
*     Callback to be triggered when a key is pressed in the field.
* @param {FormTextField~onMouseDown} [onMouseDown]
*     Callback to be triggered when the field registers a mouse down.
* @param {FormTextField~onSave} [onSave]
*     Callback to be triggered when the 'save' icon is clicked.
* @param {FormTextField~onUndo} [onUndo]
*     Callback to be triggered when the 'undo' icon is clicked.
* @param {FormTextField~onToggleReveal} [onToggleReveal]
*    Callback to be triggered when the 'reveal' button is clicked.
*
* @param {object} [controls]
*    Accepts a React object for extra controls. Used with FormIntegerField.
*
* @example
*     <FormTextField
*         data-id="my-data-id"
*         labelText={element.viewName}
*         required={element.required}
*         value="default value"
*         onValueChange={myFunction}
*     />
*/
var Stateless = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Stateless, _React$Component);

  var _super = _createSuper(Stateless);

  function Stateless() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, Stateless);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      labelWidth: 0
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleFieldChange", function (e) {
      _this.props.onValueChange(e.target.value);

      _this.props.onChange(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getInputType", function () {
      if (_this.props.maskValue && !_this.props.reveal) {
        return "password";
      } else if (_this.props.type) {
        if (_this.props.type === "color") {
          if (!_Utils.default.isProduction()) {
            console.warn("Please use the ColorPicker component.");
          }
        }

        return _this.props.type;
      } else {
        return "text";
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleFocus", function (e) {
      if (_this.props.selectOnFocus && _this.refs[_this.props["data-id"] + "-input"]) {
        _this.selectField();
      }

      _this.props.onFocus(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectField",
    /* istanbul ignore next */
    function () {
      _this.refs[_this.props["data-id"] + "-input"].select();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getAutoComplete", function () {
      if (typeof _this.props.autoComplete === "string") {
        return _this.props.autoComplete;
      } else if (_this.props.autoComplete) {
        return "on";
      } else {
        return "new-password";
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Stateless, [{
    key: "render",
    value: function render() {
      var _context2, _classnames, _context3, _context4;

      var dataId = this.props["data-id"];

      var inputType = this._getInputType();

      var message = this.props.errorMessage || this.props.message;

      var undo = _Translator.default.translate("undo");

      var save = _Translator.default.translate("save");

      var className = (0, _classnames2.default)(this.props.className, this.props.size || this.props.flexWidth ? null : (0, _InputWidths.getInputWidthClass)({
        className: this.props.className,
        width: this.props.width
      }), "input-text", (_classnames = {
        disabled: this.props.disabled,
        edited: this.props.isEdited,
        "flex-width": this.props.flexWidth
      }, (0, _defineProperty2.default)(_classnames, "flex-width-".concat(this.props.width ? this.props.width : "MD"), this.props.flexWidth), (0, _defineProperty2.default)(_classnames, "input-message", message), (0, _defineProperty2.default)(_classnames, "input-message--".concat(this.props.messageType), this.props.messageType), (0, _defineProperty2.default)(_classnames, "inline-save", this.props.showSave), (0, _defineProperty2.default)(_classnames, "masking-controls", this.props.showReveal), (0, _defineProperty2.default)(_classnames, "readonly", this.props.readOnly), (0, _defineProperty2.default)(_classnames, "required", this.props.required), (0, _defineProperty2.default)(_classnames, "value-entered", this.props.value && (0, _trim.default)(_context2 = "".concat(this.props.value)).call(_context2) !== ""), (0, _defineProperty2.default)(_classnames, "input-text--right-icon", this.props.iconRight), (0, _defineProperty2.default)(_classnames, "input-text--left-icon", this.props.iconLeft), (0, _defineProperty2.default)(_classnames, "input-text--right-arrow", this.props.withArrow), (0, _defineProperty2.default)(_classnames, "input-text--nospacing", this.props.noSpacing), (0, _defineProperty2.default)(_classnames, "input-text--flex-icon-left", this.props.flexWidth && this.props.iconLeft), _classnames));
      return /*#__PURE__*/_react.default.createElement(_FormLabel.default, (0, _extends2.default)({
        className: className,
        ref: "container",
        "data-id": dataId,
        value: this.props.labelText || this.props.label,
        hint: this.props.labelHelpText,
        lockText: this.props.labelLockText,
        style: this.state.labelWidth ? {
          width: this.state.labelWidth
        } : null
      }, (0, _FormLabel.passLabelProps)(this.props)), /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames2.default)("input-container", {
          "input-text__container--right-arrow": this.props.withArrow,
          "input-text__container--inline": this.props.inline
        }),
        "data-id": "text-field_container",
        ref: "input-container",
        onClick: this.props.onClick
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: (0, _classnames2.default)(this.props.inputClassName, {
          "input-text--inline": this.props.inline
        }),
        onFocus: this._handleFocus,
        onBlur: this.props.onBlur,
        onKeyPress: this.props.onKeyPress,
        onKeyDown: this.props.onKeyDown,
        onMouseDown: this.props.onMouseDown,
        onChange: this._handleFieldChange,
        placeholder: this.props.placeholder,
        ref: dataId + "-input",
        readOnly: this.props.readOnly,
        "data-id": dataId + "-input",
        type: inputType,
        maxLength: this.props.maxLength || this.props.size,
        name: this.props.name,
        value: this.props.value,
        autoComplete: this._getAutoComplete(),
        disabled: this.props.disabled,
        autoFocus: this.props.autoFocus,
        size: this.props.size,
        style: {
          width: this.props.size ? "auto" : null
        }
      }), this.props.flexWidth && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "flex-width-spacer\n                            ".concat(this.props.maskValue && "flex-width-spacer__password", "\n                            ")).call(_context4, this.props.showReveal || this.props.iconRight && "flex-width-spacer__reveal", "\n                            ")).call(_context3, this.props.iconLeft && "flex-width-spacer__icon-left")
      }, this.props.value), this.props.showReveal && /*#__PURE__*/_react.default.createElement("a", {
        "data-id": "reveal",
        onClick: !this.props.disabled ? this.props.onToggleReveal : null,
        className: (0, _classnames2.default)("password-show-button", {
          "icon-view-hidden": !this.props.reveal,
          "icon-view": this.props.reveal
        })
      }), this.props.children, this.props.showUndo && /*#__PURE__*/_react.default.createElement("a", {
        "data-id": "undo",
        className: "undo",
        onClick: this.props.onUndo
      }, undo), this.props.showSave && /*#__PURE__*/_react.default.createElement("a", {
        "data-id": "save",
        className: "save",
        onClick: this.props.onSave
      }, save), this.props.controls, this.props.iconRight && /*#__PURE__*/_react.default.createElement("span", {
        className: "input-icon input-icon--right"
      }, (0, _PropUtils.getIcon)(this.props.iconRight, {
        type: "inline"
      })), this.props.iconLeft && /*#__PURE__*/_react.default.createElement("span", {
        className: "input-icon input-icon--left"
      }, (0, _PropUtils.getIcon)(this.props.iconLeft, {
        type: "leading"
      })), message && /*#__PURE__*/_react.default.createElement(_FormMessage.default, {
        "data-id": dataId,
        message: message,
        type: this.props.messageType
      }), this.props.subText ? /*#__PURE__*/_react.default.createElement("span", {
        className: "sub-text"
      }, this.props.subText) : null));
    }
  }]);
  return Stateless;
}(_react.default.Component);

(0, _defineProperty2.default)(Stateless, "displayName", "FormTextFieldStateless");
(0, _defineProperty2.default)(Stateless, "propTypes", _objectSpread({
  autoComplete: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  autoFocus: _propTypes.default.bool,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  controls: _propTypes.default.object,
  description: _propTypes.default.node,
  subText: _propTypes.default.node,
  "data-id": _propTypes.default.string,
  disabled: _propTypes.default.bool,
  errorMessage: _propTypes.default.node,
  errorClassName: _propTypes.default.string,
  flexWidth: _propTypes.default.bool,
  helpClassName: _propTypes.default.string,
  iconRight: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  iconLeft: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  inputClassName: _propTypes.default.string,
  inline: _propTypes.default.bool,
  label: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object, _propTypes.default.string]),
  labelClassName: _propTypes.default.string,
  labelHelpText: _propTypes.default.node,
  labelLockText: _propTypes.default.string,
  labelText: _propTypes.default.node,
  maskValue: _propTypes.default.bool,
  maxLength: _propTypes.default.number,
  message: _propTypes.default.string,
  messageType: _propTypes.default.string,
  name: _propTypes.default.string,
  noSpacing: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onValueChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onKeyPress: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onSave: _propTypes.default.func,
  onToggleReveal: _propTypes.default.func,
  onUndo: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  type: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  required: _propTypes.default.bool,
  reveal: _propTypes.default.bool,
  showReveal: _propTypes.default.bool,
  showSave: _propTypes.default.bool,
  showUndo: _propTypes.default.bool,
  size: _propTypes.default.number,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  width: _propTypes.default.oneOf(_InputWidths.InputWidthProptypesAuto),
  withArrow: _propTypes.default.bool
}, _FormLabel.labelProps));
(0, _defineProperty2.default)(Stateless, "defaultProps", {
  autoComplete: "new-password",
  autoFocus: false,
  "data-id": "form-text-field",
  disabled: false,
  errorClassName: "",
  flexWidth: false,
  inline: false,
  maskValue: false,
  noSpacing: false,
  onBlur: _underscore.default.noop,
  onClick: _underscore.default.noop,
  onChange: _underscore.default.noop,
  onFocus: _underscore.default.noop,
  onKeyDown: _underscore.default.noop,
  onKeyPress: _underscore.default.noop,
  onMouseDown: _underscore.default.noop,
  onSave: _underscore.default.noop,
  onToggleReveal: _underscore.default.noop,
  onUndo: _underscore.default.noop,
  onValueChange: _underscore.default.noop,
  readOnly: false,
  required: false,
  reveal: false,
  selectOnFocus: false,
  showReveal: false,
  showSave: false,
  showUndo: false,
  value: ""
});
var FormTextField = (0, _StateContainer.inStateContainer)([{
  name: "reveal",
  initial: false,
  callbacks: [{
    name: "onToggleReveal",
    transform: _StateContainer.toggleTransform
  }]
}, {
  name: "value",
  initial: "",
  setter: "onValueChange"
}])(Stateless);
FormTextField.displayName = "FormTextField";
FormTextField.messageTypes = _FormMessage.default.messageTypes;
FormTextField.FormTextFieldStateless = Stateless; // we'd rather this were a named export, but the index.js/v2.jsx scheme prevents that

FormTextField.propTypes = {
  stateless: _DeprecationUtils.deprecatedStatelessProp
};
FormTextField.inputWidths = _InputWidths.InputWidths;
var _default = FormTextField;
exports.default = _default;
module.exports = exports["default"];